import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;

/**
 * Initialize FingerprintJS
 * @private
 */
const initFingerprint = () => {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }
  return fpPromise;
};

/**
 * Get browser fingerprint
 * @returns {Promise<string>} Unique fingerprint hash
 */
export const getFingerprint = async () => {
  try {
    console.log('[FINGERPRINT] Generating browser fingerprint...');

    const fp = await initFingerprint();
    const result = await fp.get();

    const fingerprint = result.visitorId;

    console.log('[FINGERPRINT] ✅ Fingerprint generated:', fingerprint);
    console.log('[FINGERPRINT] Components:', result.components);

    return fingerprint;
  } catch (error) {
    console.error('[FINGERPRINT] ❌ Error generating fingerprint:', error);
    // Fallback: gerar um ID baseado em user agent + timestamp
    const fallback = btoa(`${navigator.userAgent}-${Date.now()}`).substring(0, 32);
    console.log('[FINGERPRINT] Using fallback:', fallback);
    return fallback;
  }
};

export default { getFingerprint };
